

import { useNavigate } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import { fetchBlogs } from "../../redux/actions/action";
const BlogsHomePage = () => {
  const navigate = useNavigate();
  const blogs = useSelector((state) => state.uploadBlog.newBlog);
  const dispatch = useDispatch();


  const topics = [
      { name: "Artificial Intelligence(AI)", description: "Unleashing the power of machine learning and AI to create intelligent systems that adapt, learn, and transform industries.", image: "Group 2 1.png" },
      { name: "Internet Of Things(IOT)", description: "Connecting the physical and digital world, driving innovation in smart technologies for a connected future.", image: "iot image.png" },
      { name: "Cloud Computing", description: "Shape the future of computing infrastructure, enabling scalable, flexible and reliable solutions in the cloud.", image: "cloud image.png" },
      { name: "Web Applications", description: "Crafting seamless and web-centric experiences through innovative applications that harness the latest technologies.", image: "webapplication.png" },
      { name: "Cybersecurity", description: "Fortifying digital landscapes against evolving threats through innovative cybersecurity solutions and robust defense mechanisms.", image: "Cyber security.png" },
      { name: "Databases", description: "Designing scalable and efficient database systems that underpin data-driven decision-making and analytics.", image: "databases.png" },
  ];

  useEffect(() => {
    if (!blogs || blogs.length === 0) {
      console.log("🔄 Fetching blogs again...");
      dispatch(fetchBlogs());
    }
  }, [dispatch, blogs]);

  if (!Array.isArray(blogs)) {
    console.log("Blogs is undefined or not an array")
    return <p>Loading Blogs</p>; // Prevent further rendering until data is available
}
console.log("blogs",blogs)
 const clickArchive = useCallback(()=>{
    navigate('/viewarchive')
 },[navigate])

  
  return (
      <div className="relative bg-gray min-h-screen overflow-hidden w-full">
        
              <Header />

          <main className="container mx-auto px-10 pt-[120px]">

          <div className="relative text-white py-4 m-2 flex flex-col items-start ml-4 md:ml-20 max-w-full min-h-screen overflow-y-auto">
  <h2 className="text-4xl font-bold mb-1">Blogs</h2>

  <div className="relative mt-5">
    {/* Your content here */}
  

     <img src="Rectangle 3.svg" alt="blog image" className="w-[500px] h-[500px] ml-0 border rounded-xl md:w-[700px] md:h-[400px] object-cover"/>

     <div className="absolute top-0 left-0 text-white p-4">
     <h2 className="text-lg font-semibold">Tech Trends Today</h2>  
        <h1 className="text-4xl font-bold mt-2">Knowledge Hub</h1>

     </div>
     </div>
 
     

                  {topics.map((topic, index) => {
          
  const topicBlogs = Array.isArray(blogs)
    ? blogs.filter((b) => b.topicName && b.topicName.trim().toLowerCase() === topic.name.trim().toLowerCase())
    : [];
             
                      return (
                          <div key={index} className="w-full mt-14">
                              <div className="w-full h-auto bg-indigo-900 py-1 rounded-t-xl">
                                  <b className="text-lg font-semibold p-2">{topic.name}</b>
                              </div>

                              <div className="h-auto bg-white rounded-b-xl relative px-4 pb-4">
                                  <div className="flex items-start">
                                      <img src={topic.image} alt={topic.name} className="w-30 h-30 object-cover rounded-md" />
                                      <div className="ml-10 mt-5 font-poppins font-medium text-black inline-block w-[400px]">
                                          <b>{topic.description}</b>
                                      </div>
                                  </div>

                                 {/* Read More Link for Each Topic */}
                                  <div className="mt-3 flex justify-end">
                                      <Link to={`/readmore/${encodeURIComponent(topic.name)}`} className="text-black font-semibold">
                                          Read more...
                                      </Link>
                                  </div>
                              </div>
                          </div>
                      );
                  })}
              </div>
          
          {/* Footer Section */}
                        <div className="ml-20 flex flex-row justify-evenly items-center gap-6">


          <div className="bg-white mt-10 rounded-xl h-auto max-w-[800px] ">
            <div className="w-auto h-auto m-1 bg-indigo-900 py-3 rounded-xl">
              <div className="text-xs mb-5 ml-10 text-white">
                <b>If you're interested in writing a Blog and sharing your ideas, feel free to reach out to us.</b>
              </div>

              {/*viewarchive*/}
              {/* <div> */}
   

{/* </div> */}
{/* </div> */}
{/* </div> */}
              {/*end*/}

              <div className="ml-20 flex flex-row justify-evenly">
                <div className="flex flex-row">
                  <img className="h-6 w-6 mr-3" alt="" src="/icon1.png" />
                  <b className="cursor-pointer text-white">info@Innohubrc.com</b>
                </div>

                <div className="flex flex-row gap-[13px]">
                  <img className="h-6 w-6" alt="" src="/icon.svg" />
                  <div className="flex-1 text-white">
                    <p>+91 080-23100098</p>
                    <p>+91 63635 07858</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button   onClick={clickArchive}       
        
        className="bg-color cursor-pointer hover:bg-blue-700 text-white font-bold rounded lg:w-[60px] lg:mr-[-30px]  xl:w-[150px] xl:mt-2 xl:mr-40 h-[50px] "
       > ViewArchive
        </button>
          </div>
        </main>

        <div className="bg-indigo-900 mt-10" >
          <Footer />
        </div>
      </div>
    // </div>
  );
};

export default BlogsHomePage;



